import { EXTRALARGE } from "shared/variables";
import { MaxWidth } from "components/MaxWidth";
import { SrcSet } from "components/SrcSet";
import styles from "./Hero.module.css";

export const Hero = ({ image, title, text }) => (
  <div className={styles.container}>
    <div className={styles.imageContainer}>
      {image.src && (
        <SrcSet
          alt={image.alt}
          className={styles.image}
          sizes={[
            { minWidth: 1400, width: 1920, height: 520 },
            { minWidth: 1024, width: 1400, height: 520 },
            { minWidth: 900, width: 1024, height: 520 },
            { minWidth: 768, width: 900, height: 520 },
            { minWidth: 700, width: 768, height: 480 },
            { minWidth: 600, width: 700, height: 480 },
            { minWidth: 500, width: 600, height: 480 },
            { minWidth: 400, width: 500, height: 480 },
            { minWidth: 345, width: 400, height: 480 },
            { minWidth: 1, width: 345, height: 480 },
          ]}
          src={image.src}
        />
      )}
    </div>
    <div className={styles.overlay} />
    <div className={styles.content}>
      <MaxWidth size={EXTRALARGE}>
        <div className={styles.contentLimiter}>
          {title && <HeroTitle>{title}</HeroTitle>}
          {text && <p className={styles.description}>{text}</p>}
        </div>
      </MaxWidth>
    </div>
  </div>
);

const HeroTitle = ({ children = "" }) => (
  <h1
    className={styles.heroTitle}
    dangerouslySetInnerHTML={{
      __html: children
        .replace(/\*(.+)\*/gm, "<strong>$1</strong>")
        .replace(/\n/g, "<br />"),
    }}
  />
);
